// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

// import HelloController from "./hello_controller"
// application.register("hello", HelloController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)
import MfaCodeController from "./mfa_code_controller"
application.register("mfa-code", MfaCodeController)
import QaApiController from "./qa_api_controller"
application.register("qa-api", QaApiController)
